import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard {

	constructor(
		private readonly auth: AuthService,
		private readonly router: Router
	) { }

	/**
	 * Can activate validation.
	 * @param route: ActivatedRouteSnapshot
	 * @param state: RouterStateSnapshot
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (!this.auth.isAuthenticated()) {
			this.router.navigate(['login']);
			return of(false);
		} else {
			return of(true);
		}
	}
}
